var _rect, _line, _line2, _path, _line3, _line4, _rect2, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_9025730_microsoft_excel_logo_icon",
    "data-name": "9025730_microsoft_excel_logo_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20768",
    "data-name": "Rectangle 20768",
    width: 20,
    height: 20,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    x2: 4.375,
    transform: "translate(11.875 7.5)",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    x2: 4.375,
    transform: "translate(11.875 12.5)",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49064",
    "data-name": "Path 49064",
    d: "M64,35.125v-2.5A.625.625,0,0,1,64.625,32h10a.625.625,0,0,1,.625.625v13.75a.625.625,0,0,1-.625.625h-10A.625.625,0,0,1,64,46.375v-2.5",
    transform: "translate(-59 -29.5)",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    y2: 3.125,
    transform: "translate(10.625 14.375)",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    y2: 3.125,
    transform: "translate(10.625 2.5)",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20769",
    "data-name": "Rectangle 20769",
    width: 9.375,
    height: 8.75,
    rx: 4.375,
    transform: "translate(2.5 5.625)",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x2: 2.813,
    y2: 3.75,
    transform: "translate(5.781 8.125)",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x1: 2.813,
    y2: 3.75,
    transform: "translate(5.781 8.125)",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.28433527f21d25858b7a5e8b647b4f53.svg";
export { ForwardRef as ReactComponent };